<div class="dataTables_length"><label class="d-inline-flex align-items-center">
    <span class="entries-title-left">{{ "Show" | translate | async }}</span>
    <select class="select-item-range form-control" [(ngModel)]="parameter" (ngModelChange)="onChange()">
        <option label="10" value="10" [disabled]="isOptionDisabled(10)">10</option>
        <option label="25" value="25" [disabled]="isOptionDisabled(25)">25</option>
        <option label="50" value="50" [disabled]="isOptionDisabled(50)">50</option>
        <option label="100" value="100" [disabled]="isOptionDisabled(100)">100</option>
    </select>
    <span class="entries-title-right">{{ "entries" | translate | async }}</span>
</label>
</div>
